export const elevationOne = '0 0 0 1px rgba(0, 0, 0, 0.05)';
export const elevationTwo = '0 1px 2px 0 rgba(0, 0, 0, 0.05)';
export const elevationThree = '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)';
export const elevationFour = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
export const elevationFive = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)';
export const elevationSix = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
export const elevationSeven = '0 25px 50px -12px rgba(0, 0, 0, 0.25)';
export const ELEVATION_MAP = {
  '0': 'none',
  '1': elevationOne,
  '2': elevationTwo,
  '3': elevationThree,
  '4': elevationFour,
  '5': elevationFive,
  '6': elevationSix,
  '7': elevationSeven
};
//# sourceMappingURL=elevations.js.map